import { SYNC_TO_DESKTOP_APP_KEYS } from '@/types/sync/SyncKeys.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { WS_REQUEST } from '@/types/ws/WebSocketEvents.ts';
import { WebSocketService } from '@/ws/WebSocketService.ts';
import type { SyncTarget } from '@/types/sync/SyncTarget.ts';
import { v4 as uuidv4 } from 'uuid';

export const syncToDesktopAppAction = (key: SYNC_TO_DESKTOP_APP_KEYS, value: string): void => {
    const sessionStore = useSessionStore();
    if (!sessionStore.isInsideWebView) {
        throw new Error('syncToDesktopAppAction should not be called from inside the desktop app');
    }

    const target: SyncTarget = 'desktop-app';

    WebSocketService.instance.send(WS_REQUEST.sync_clientSync, {
        id: uuidv4(),
        target: target,
        key: key,
        value: value,
    });
};
